import { Book } from "@/types/Book";
import Image from "next/image";

interface BookImageProps {
  book: Book;
  width: number;
  height: number;
  className?: string;
}

function BookImage({ book, width, height, className, ...rest }: BookImageProps) {
  const PLACEHOLDER_IMAGE = "https://placehold.co/300x400.png?text=No+Image";
  const AMAZON_PLACEHOLDER = "https://m.media-amazon.com/images/I/01RmK+J4pJL.gif";

  const bookImage =
    !book.bookImage || book.bookImage === AMAZON_PLACEHOLDER
      ? PLACEHOLDER_IMAGE
      : book.bookImage;

  return (
    <Image
      {...rest}
      src={bookImage}
      alt={`${book.title} cover`}
      width={width}
      height={height}
      className={`object-cover ${className || ""}`}
    />
  );
}

export default BookImage;
